import {ResourceParams, resources} from "../../../../../../../core/models/resource/resources";

export const noteFilesResourceParams: ResourceParams = resources['note-files'];
